function initializeTabsSlider() {
  document
    .querySelectorAll(".collection-tabs--media--content--outer--wrapper")
    .forEach((sectionEl) => {
      const sectionId = sectionEl.getAttribute("data-section-id");
      const cardContainers = sectionEl.querySelectorAll(
        ".collection-tabs--media--content--outer--wrapper .tabs-products-card"
      );

      function initSlider(card) {
        const $card = $(card);
        const listLength = $card.find("li").length;
        //alert(listLength)
        if (listLength > 5) {
          if (!$card.hasClass("slick-initialized")) {
            $card.slick({
              infinite: false,
              slidesToShow: 5,
              slidesToScroll: 1,
              arrows: true,
              dots: false,
              prevArrow:
                '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="35" height="21" viewBox="0 0 35 21" fill="none"><path d="M34.5805 8.72843H8.17093L12.9589 3.94043L9.98533 0.966831L0.106934 10.8452L9.98533 20.7236L12.9589 17.75L8.17093 12.9116H34.5805V8.72843Z" fill="#000"/></svg></div>',
              nextArrow:
                '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none"><path d="M8.41943 22.7284H34.829L30.041 17.9404L33.0146 14.9668L42.893 24.8452L33.0146 34.7236L30.041 31.75L34.829 26.9116H8.41943V22.7284Z" fill="#000"/></svg></div>',
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  },
                },
              ],
            });
          }

          requestAnimationFrame(() => {
            setTimeout(() => $card.slick("setPosition"), 50);
            setTimeout(() => $card.slick("setPosition"), 300);
          });
        } else {
          if ($card.hasClass("slick-initialized")) {
            $card.slick("unslick");
          }
        }
      }

      // Initialize the first active card inside this section
      const firstCard = sectionEl.querySelector(".tabs-products-card.active");
      if (firstCard) initSlider(firstCard);

      // Tab click handler
      const tabWrapper = sectionEl.querySelector(
        ".collection-tabs--media--tabs"
      );
      if (!tabWrapper) return;

      tabWrapper.querySelectorAll("li").forEach((tab) => {
        tab.addEventListener("click", function () {
          const tabHead = tab.getAttribute("data-attr");

          // Remove active from all tabs in this section
          tabWrapper
            .querySelectorAll("li")
            .forEach((el) => el.classList.remove("active"));
          tab.classList.add("active");

          // All cards/buttons in this section
          const tabCards = sectionEl.querySelectorAll(".tabs-products-card");
          const tabButtons = sectionEl.querySelectorAll(
            ".button-collections-link"
          );
          const tabTitles = sectionEl.querySelectorAll(
            ".collection-title-description"
          );

          // Hide all cards & buttons
          tabCards.forEach((card) => {
            if ($(card).hasClass("slick-initialized")) {
              $(card).slick("unslick");
            }
            $(card).hide().removeClass("active");
          });

          $(tabButtons).hide().removeClass("active");
          $(tabTitles).hide().removeClass("active");

          // Show matching card
          const targetCard = sectionEl.querySelector(
            `.tabs-products-card[data-attr='${tabHead}']`
          );
          if (targetCard) {
            $(targetCard).fadeIn(200).css("display", "flex").addClass("active");
            initSlider(targetCard);
          }

          // Show matching title
          const targetTitle = sectionEl.querySelector(
            `.collection-title-description[data-attr="${tabHead}"]`
          );
          if (targetTitle) {
            $(targetTitle).fadeIn(200).addClass("active");
          }

          // Show matching button
          const targetBtn = sectionEl.querySelector(
            `.button-collections-link[data-attr="${tabHead}"]`
          );
          if (targetBtn) {
            $(targetBtn)
              .fadeIn(200)
              .css("display", "inline-flex")
              .addClass("active");
          }
          setTimeout(function () {
            $(".product-options-wrapper").each(function () {
              if ($(this).find("p").length === 0) {
                $(this).hide();
              }
            });
          }, 500);
        });
      });
    });
}

// Initial and dynamic load
$(document).ready(function () {
  initializeTabsSlider();
});

document.addEventListener("shopify:section:load", initializeTabsSlider);
document.addEventListener("shopify:block:select", initializeTabsSlider);
document.addEventListener("tabsSlider:reload", initializeTabsSlider);
